import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import ValuationWidget from "@/pages/ValuationWidget";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import ValuationDisclaimer from "@/pages/ValuationDisclaimer";
import AdminDashboard from "@/pages/AdminDashboard";
import EmbedPreview from "@/pages/EmbedPreview";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/valuation" element={<ValuationWidget />} />
          <Route path="/ValuationEcom" element={<ValuationWidget resultsPage={true} />} />
          <Route path="/widget" element={<ValuationWidget />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/disclaimer" element={<ValuationDisclaimer />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/embed" element={<EmbedPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
